import type { ProcessingStatus } from '@clm/shared-types';

import type { TileTone } from '../components/charts/StatTile';
import { PROCESSING_LABELS } from '../components/trust-labels';

/**
 * What the two Analytics boards share — CLM-81. A plain module (no component)
 * so fast refresh stays whole, the `pipeline-status-chips.ts` pattern.
 */

export const ANALYTICS_FORBIDDEN_COPY =
  'The Analytics boards read the contracts in your scope under contract:read, which every CLM role holds. ' +
  'If you see this, your account has no CLM role mapped yet.';

/** D-81-2 — the reference's money line is absent on purpose, and the page says so. */
export const NO_MONEY_COPY = 'Contract value is stored as the extracted phrase, so no money totals are shown.';

/**
 * The pipeline labels — `trust-labels.ts`'s, so the boards, the Pipeline page
 * and every raw print share one map. CLM-108 (R-108-14): `Verified` reads
 * **"Settled"**, because an auto-approved contract reaches it too; the
 * status-mix donut's segment and the Overview's tile follow with no code here.
 */
export const STATUS_LABELS: Readonly<Record<ProcessingStatus, string>> = PROCESSING_LABELS;

/** Tone → existing token pair; no new colour (D-81-1). */
export const STATUS_TONES: Readonly<Record<ProcessingStatus, TileTone>> = {
  PendingExtraction: 'acc',
  Converted: 'ai',
  Pseudonymised: 'ai',
  Extracted: 'ai',
  PendingVerification: 'acc',
  Verified: 'ok',
  ExtractionFailed: 'bad',
  manual_entry_pending: 'acc',
};

/** The browser's local midnight, as a UTC instant — the "N today" boundary (D-81-9). */
export function localDayStartUtc(now: Date = new Date()): string {
  const midnight = new Date(now);
  midnight.setHours(0, 0, 0, 0);
  return midnight.toISOString();
}
